export enum OrderStateStatus {
  YET_TO_START_WORK_ON_ORDER = "yet_to_start_work_on_order",
  ORDER_IN_PROGRESS = "order_in_progress",
  ORDER_COMPLETED_BY_HUMAN = "order_completed_by_human",
  ORDER_COMPLETED_BY_AGENT = "order_completed_by_agent",
}
